import {Injectable} from '@angular/core';
import {WindowRefService} from '../../services/window-ref.service';
import {LoggerService} from './logger.service';

@Injectable()
export class LogExceptionsService {

    constructor(
        private loggerService: LoggerService,
        private windowRefService: WindowRefService
    ) {}

    public init(): void {
        if (this.loggerService.isLoggerApiEnabled) {
            const prevOnError = this.windowRefService.nativeWindow.onerror;

            this.windowRefService.nativeWindow.onerror = (message, url, line, column, error) => {
                const errorRelatedData = {
                    message,
                    url,
                    line,
                    column
                };

                this.loggerService.error(errorRelatedData, error);

                prevOnError?.(message, url, line, column, error);
            };
        }
    }

}
